<template>
  <div class="the-navbar__user-meta flex items-center" v-if="currentUser">

    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ fullName }}</p>
      <small>{{ roleName }}</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <div class="con-img ml-3">
        <feather-icon icon="SettingsIcon"/>
        <!-- <img v-if="currentUserPhoto" key="onlineImg" :src="currentUserPhoto" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" /> -->
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 12rem">

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"  @click="navigateToInstallmentCalculation">
            <feather-icon icon="DollarSignIcon" svgClasses="w-4 h-4"/>
            <span class="ml-2">{{ $t('sections.headerMenu.InstallmentCalculation.title') }}</span>
          </li>

          <vs-divider class="m-1"/>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4"/>
            <span class="ml-2">{{ $t('layout.nav-bar.logout') }}</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  computed: {
    currentUserPhoto() {
      return this.$store.getters['getCurrentUserPhoto']
    },
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
    currentUser() {
      return this.$store.state.currentUser
    },
    fullName() {
      if (!this.currentUser) return "";
      if (!this.currentUser.prefix) return `${this.currentUser.name} ${this.currentUser.surname}`.trim();
      const prefix = this.currentUser.prefix.nameTh || "";
      return `${prefix}${this.currentUser.name} ${this.currentUser.surname}`.trim();
    },
    roleName() {
      if (!this.currentUser) return "";

      return this.currentUser.role.nameTh;
    }
  },
  methods: {
    logout() {
      this.$vs.loading()
      this.$store.dispatch('signOut', this)
      setTimeout(() => {
        this.$vs.loading.close()
      }, 2000)
    },
    navigateToInstallmentCalculation() {
      this.$router.push({name: 'Installment-calculation', params: {}}).catch(() => {});
    }
  }
}
</script>
